<template>
  <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
    <div :class="`mb-2 ${group ? 'form-group' : ''}`">
      <label class="d-block font-weight-bold">
        {{ label }}
        <span
          v-if="!item"
          class="small text-warning"
          style="font-size: 10px"
          v-b-tooltip.hover
          title="Campo vazio!"
          ><i class="fas fa-exclamation"></i
        ></span>
        <b-link
          v-if="ajuda"
          href="#"
          @click.prevent="void 0"
          class="mb-2"
          variant="info"
          v-b-popover.hover.top="ajuda"
        >
          <i class="fas fa-info-circle"></i>
        </b-link>
        <span v-if="required" class="text-danger">*</span>
        <small>{{ sublabel }}</small>
      </label>

      <div :class="group ? 'input-group mb-3' : ''">
        <input
          v-model="item"
          v-on:input="
            $emit('input', uppercase ? toUpper(item) : item), $emit('change')
          "
          :type="type ? type : 'text'"
          class="form-control px-1"
          :class="
            label == undefined ? (mt == undefined ? 'mt-4' : `mt-${mt}`) : ''
          "
          :min="min"
          :max="max"
          :readonly="readonly"
          :disabled="disabled"
          :placeholder="placeholder ? placeholder : label"
          :required="required"
          :style="uppercase ? 'text-transform: uppercase' : ''"
          ref="input"
          style="border-right: 0 solid white"
        />
        <div
          class="input-group-text-button py-0 pr-1 pl-0"
          style="cursor: pointer; width: 26px"
          v-if="group"
          @click="$emit('submit')"
        >
          <!-- <a class="px-1 btn btn-default" > -->
          <i
            :class="iconBtn"
            v-if="iconBtn"
            style="position: absolute; right: 5px; bottom: 5px"
          ></i>
          <span v-else>{{ btnText }}</span>
          <!-- </a> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Money } from "v-money";
  export default {
    components: { Money },
    props: [
      "type",
      "value",
      "label",
      "sublabel",
      "required",
      "grid",
      "readonly",
      "disabled",
      "placeholder",
      "mt",
      "group",
      "iconBtn",
      "btnText",
      "uppercase",
      "ajuda",
      "min",
      "max",
    ],
    data() {
      return {
        item: null,
        money: {
          decimal: ",",
          thousands: "",
          prefix: "",
          suffix: "",
          precision: 0,
          masked: false,
        },
      };
    },
    beforeMount() {
      // if (this.type == "money") {
      //     this.item = this.value + ",00";
      // } else {
      //     this.item = this.value;
      // }
      this.item = this.value;
    },
    watch: {
      value(n, o) {
        this.item = n;
      },
    },
    methods: {
      toUpper(item) {
        return item.toUpperCase();
      },
    },
  };
</script>
<style lang="css">
  .input-group-text-button {
    background-color: #ffffff !important;
    border: 1px solid #e4e5e7 !important;
    color: #808185 !important;
    border-left: 0 !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    border-bottom-left-radius: 0 !important;
  }
</style>